// components/Shared/CheckBoxGroup.tsx
import { FormGroup, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

interface ICheckBoxGroupProps {
  name: string;
  options: string[]; // lista de literales
  labelMap?: Record<string, string>; // opcional: mostrar un texto distinto del valor
}

export const CheckBoxGroup: React.FC<ICheckBoxGroupProps> = ({
  name,
  options,
  labelMap = {},
}) => {
  const { watch, setValue, formState: { errors } } = useFormContext();
  const selected: string[] = watch(name) || [];

  const toggle = (value: string) => {
    if (selected.includes(value)) {
      setValue(
        name,
        selected.filter((v) => v !== value),
        { shouldValidate: true, shouldDirty: true }
      );
    } else {
      setValue(name, [...selected, value], {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };
  

  return (
    <>
    <FormGroup>
      {options.map((opt) => (
        <FormControlLabel
          key={opt}
          control={
            <Checkbox
              checked={selected.includes(opt)}
              onChange={() => toggle(opt)}
            />
          }
          label={labelMap[opt] || opt}
        />
      ))}
    </FormGroup>
    {errors[name]?.message && (
        <Typography
          color="error"
          fontSize={"12px"}
          sx={{ mt: 1 }}
        >
          {errors[name]?.message?.toString()}
        </Typography>
      )}
    </>
  );
};
